import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Table, TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { catchError, forkJoin, Observable, of } from 'rxjs';
import { Club } from '../../../model/Club';
import { HttpResponse } from '../../../model/HttpResponse';
import { ProcessStatus } from '../../../model/ProcessStage';
import { QueryOptionDto } from '../../../model/QueryOptionDto';
import { AcademyAdministratorOperation } from '../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../model/administrator/AdministratorEntity';
import { Competition } from '../../../model/competitions/Competition';
import { Registration } from '../../../model/competitions/Registration';
import { RegistrationPaymentStatus } from '../../../model/enum/RegistrationPaymentStatus';
import { RegistrationStatus } from '../../../model/enum/RegistrationStatus';
import { RegistrationType } from '../../../model/enum/RegistrationType';
import { TemporalRegistration } from '../../../model/enum/TemporalRegistration';
import { Member } from '../../../model/member';
import { ClubService } from '../../../services/club.service';
import { CompetitionService } from '../../../services/competition.service';
import { DocumentsService } from '../../../services/documents.service';
import { GestionService } from '../../../services/gestion.service';
import { LoadingService } from '../../../services/loading.service';
import { ReportService } from '../../../services/report.service';
import { RoleService } from '../../../services/role.service';
import { CompetitionsComponent } from '../../events-gestor/competitions/competitions.component';
import { SolicitudesTableComponent } from '../../gestor/solicitudes/solicitudes-table/solicitudes-table.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
  selector: 'app-financial-events',
  standalone: true,
  templateUrl: './financial-events.component.html',
  styleUrl: './financial-events.component.scss',
  providers: [MessageService],
  imports: [
    PageHeaderComponent,
    TabViewModule,
    BadgeModule,
    AvatarModule,
    CommonModule,
    PageHeaderComponent,
    TableModule,
    ButtonModule,
    ToolbarModule,
    ToastModule,
    InputTextModule,
    TooltipModule,
    DialogModule,
    SolicitudesTableComponent,
    SelectButtonModule,
    FormsModule,
    InputTextareaModule,
    CompetitionsComponent,
    TagModule,
  ],
})
export class FinancialEventsComponent implements OnInit {
  competitions: Competition[] = [];

  tabs = [
    {
      label: 'Validaciones Pendientes',
      value: 'MANUAL_PAYMENTS',
    },
    {
      label: 'Historial de Verificaciones',
      value: 'VERIFICATION_HISTORY',
    },
  ];
  modalitieTabIndex: number = 0;
  tabSelected: string = 'MANUAL_PAYMENTS';
  registrationsWithManualPayment: Registration[] = [];
  showPaymenManualValidation: boolean = false;
  registrationsByPayment: any[] = [];

  // ======================================
  // 📚 Historial de verificaciones
  // ======================================
  showVerificationHistory: boolean = false;
  verifiedPayments: any[] = [];
  filteredVerifiedPayments: any[] = [];
  historyStatusFilter: string = 'ALL';
  historyStatusOptions: any[] = [
    { label: 'Todos', value: 'ALL' },
    { label: 'Aprobados', value: 'APPROVED' },
    { label: 'Rechazados', value: 'REJECTED' },
  ];
  documentPreviewSelected: any = null;
  showDocumentPreview: boolean = false;
  showRegistrationsDetails: boolean = false;
  registrationsByPaymentSelected: Registration[] = [];
  showRevisionConceptModal: boolean = false;
  paymentStatusOptions: any[] = [
    { label: 'APROBADO', value: ProcessStatus.APPROVED },
    { label: 'NO APROBADO', value: ProcessStatus.REJECTED },
  ];
  paymentRejectReason: string = '';
  showVinculationDetails: boolean = false;
  paymentStatusSelected: string = 'approved';
  clubes: Club[] = [];
  membersOfPayment: Member[] = [];
  /** Grupo de pago que se está consultando en el modal de inscritos */
  paymentGroupSelected: any = null;
  /** Filas del modal: se arman desde las inscripciones, no desde los deportistas */
  registrationsOfPaymentDetail: any[] = [];
  /** Inscripciones cuyo deportista ya no existe porque el club lo eliminó */
  orphanRegistrationsCount: number = 0;
  constructor(
    private competitionService: CompetitionService,
    private loadingService: LoadingService,
    private messageService: MessageService,
    private documentsService: DocumentsService,
    private sanitizer: DomSanitizer,
    private clubService: ClubService,
    private gestionService: GestionService,
    private roleService: RoleService,
    private reportService: ReportService
  ) {}

  ngOnInit(): void {
    this.onModalitieTabChange({ index: this.modalitieTabIndex });
    this.getCompetitions();
  }

  getCompetitions() {
    this.loadingService.showLoading();
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.SELECT,
      type: AcademyAdministratorType.COMPETIIONS,
      payload: null,
    };
    this.competitionService
      .sendRequest(entity)
      .subscribe((response: HttpResponse) => {
        if (response.code === 200) {
          this.competitions = response.response as Competition[];
          this.getClubes();
        }
        this.loadingService.hideLoading();
      });
  }

  getClubes() {
    this.loadingService.showLoading();
    this.clubService.getAllClubs().subscribe((response: HttpResponse) => {
      if (response.code === 200) {
        this.clubes = response.response as Club[];
        // El historial puede haberse cargado antes que clubes y eventos
        this.enrichVerifiedPayments();
        this.applyHistoryFilter();
      }
      this.loadingService.hideLoading();
    });
  }

  onModalitieTabChange(event: any) {
    this.tabSelected = this.tabs[event.index].value;
    if (this.tabSelected === 'MANUAL_PAYMENTS') {
      this.getVinculationWithManualPayment();
      this.showVerificationHistory = false;
    }
    if (this.tabSelected === 'VERIFICATION_HISTORY') {
      this.showPaymenManualValidation = false;
      this.getVerifiedPayments();
    }
  }

  getClub(clubId: string) {
    return this.clubes.find((club:Club) => club.id === clubId);
  }

  getCompetition(competitionId: string) {
    return this.competitions.find(
      (competition) => competition.id === competitionId
    );
  }

  getVinculationWithManualPayment() {
    this.loadingService.showLoading();
    const queryOptions: QueryOptionDto = {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'status',
            logicOperator: '=',
            parameterName: '@Status',
            parameterValue: 'PRE_REGISTERED',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'payment.paymentType',
            logicOperator: '=',
            parameterName: '@PaymentType',
            parameterValue: 'MANUAL_PAYMENT',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'payment.paymentStatus',
            logicOperator: '=',
            parameterName: '@PaymentStatus',
            parameterValue: 'PAYMENT_MANUAL_VALIDATION',
          },
        ],
      },
    };
    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.SELECT,
      type: AcademyAdministratorType.REGISTRATIONS,
      payload: queryOptions,
    };
    this.competitionService
      .sendRequest(entity)
      .subscribe((response: HttpResponse) => {
        if (response.code === 200) {
          this.registrationsWithManualPayment =
            response.response as Registration[];
          this.groupByApplicationByPayment();
        }
        this.loadingService.hideLoading();
      });
  }

  groupByApplicationByPayment() {
    this.registrationsByPayment = [];

    for (const registration of this.registrationsWithManualPayment) {
      const clubId = registration.clubId;
      const paymentId = registration.payment.paymentId;

      const index = this.registrationsByPayment.findIndex(
        (registrationByPayment) => registrationByPayment.paymentId === paymentId
      );

      if (index === -1) {
        this.registrationsByPayment.push({
          clubId: clubId,
          paymentId: paymentId,
          registrations: [registration],
        });
      } else {
        this.registrationsByPayment[index].registrations.push(registration);
      }
    }
    this.showPaymenManualValidation = true;
  }

  /**
   * Consulta las inscripciones cuyo pago manual ya fue verificado (aprobado o rechazado),
   * para conservar la trazabilidad después de emitir el concepto.
   */
  getVerifiedPayments() {
    this.loadingService.showLoading();

    const verifiedStatuses = [
      RegistrationPaymentStatus.PAYMENT_MANUALLY_APPROVED,
      RegistrationPaymentStatus.PAYMENT_MANUALLY_REJECTED,
    ];

    const requests: Observable<HttpResponse>[] = verifiedStatuses.map(
      (paymentStatus) => {
        const queryOptions: QueryOptionDto = {
          options: {
            conditionals: [
              {
                conditionalConnector: 'AND',
                evaluatedProperty: 'payment.paymentType',
                logicOperator: '=',
                parameterName: '@PaymentType',
                parameterValue: 'MANUAL_PAYMENT',
              },
              {
                conditionalConnector: 'AND',
                evaluatedProperty: 'payment.paymentStatus',
                logicOperator: '=',
                parameterName: '@PaymentStatus',
                parameterValue: paymentStatus,
              },
            ],
          },
        };
        const entity: AdministratorEntity = {
          operation: AcademyAdministratorOperation.SELECT,
          type: AcademyAdministratorType.REGISTRATIONS,
          payload: queryOptions,
        };
        return this.competitionService
          .sendRequest(entity)
          .pipe(
            catchError(() => of({ code: 204, response: [] } as HttpResponse))
          );
      }
    );

    forkJoin(requests).subscribe({
      next: (responses: HttpResponse[]) => {
        const registrations = responses.reduce(
          (accumulated: Registration[], response: HttpResponse) =>
            response.code === 200 && Array.isArray(response.response)
              ? accumulated.concat(response.response as Registration[])
              : accumulated,
          []
        );
        this.groupVerifiedPayments(registrations);
        this.showVerificationHistory = true;
        this.loadingService.hideLoading();
      },
      error: () => {
        this.groupVerifiedPayments([]);
        this.showVerificationHistory = true;
        this.loadingService.hideLoading();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No fue posible consultar el historial de verificaciones',
          life: 4000,
        });
      },
    });
  }

  /** Agrupa las inscripciones verificadas por pago y precalcula cantidades y valores */
  groupVerifiedPayments(registrations: Registration[]) {
    const groups: any[] = [];

    for (const registration of registrations) {
      const paymentId = registration.payment?.paymentId;
      if (!paymentId) {
        continue;
      }
      let group = groups.find((item) => item.paymentId === paymentId);
      if (!group) {
        group = {
          paymentId: paymentId,
          clubId: registration.clubId,
          competitionId: registration.competitionId,
          registrations: [],
        };
        groups.push(group);
      }
      group.registrations.push(registration);
    }

    this.verifiedPayments = groups;
    this.enrichVerifiedPayments();
    this.verifiedPayments.sort((a, b) =>
      `${b.verificationDate}`.localeCompare(`${a.verificationDate}`)
    );
    this.applyHistoryFilter();
  }

  /**
   * Calcula nombres, cantidades y valores de cada verificación. Es idempotente y se
   * vuelve a ejecutar cuando terminan de cargar clubes y eventos, ya que el historial
   * puede consultarse antes de que esos catálogos estén disponibles.
   */
  enrichVerifiedPayments() {
    for (const group of this.verifiedPayments) {
      const memberRegistrations = group.registrations.filter(
        (registration: Registration) =>
          registration.registrationType === RegistrationType.MEMBER_REGISTRATION
      );
      const ordinary = memberRegistrations.filter(
        (registration: Registration) =>
          registration.temporalType === TemporalRegistration.ORDINARY
      );
      const extraordinary = memberRegistrations.filter(
        (registration: Registration) =>
          registration.temporalType === TemporalRegistration.EXTRAORDINARY
      );
      const clubRegistration = group.registrations.find(
        (registration: Registration) =>
          registration.registrationType === RegistrationType.CLUB_REGISTRATION
      );
      const reference: Registration = group.registrations[0];

      group.clubName =
        this.getClub(group.clubId)?.name ?? 'Club no identificado';
      group.competitionName =
        this.getCompetition(group.competitionId)?.name ?? 'Evento no encontrado';
      group.ordinaryCount = ordinary.length;
      group.ordinaryAmount = this.calculateAmountOfRegistrations(
        ordinary,
        TemporalRegistration.ORDINARY
      );
      group.extraordinaryCount = extraordinary.length;
      group.extraordinaryAmount = this.calculateAmountOfRegistrations(
        extraordinary,
        TemporalRegistration.EXTRAORDINARY
      );
      group.clubAmount = this.calculateClubAmount(clubRegistration);
      group.totalAmount =
        group.ordinaryAmount + group.extraordinaryAmount + group.clubAmount;
      group.registrationsCount = memberRegistrations.length;
      group.paymentStatus = reference.payment?.paymentStatus ?? '';
      group.isApproved =
        group.paymentStatus ===
        RegistrationPaymentStatus.PAYMENT_MANUALLY_APPROVED;
      group.statusLabel = group.isApproved ? 'Aprobado' : 'Rechazado';
      group.statusSeverity = group.isApproved ? 'success' : 'danger';
      group.verificationDate =
        reference.auditData?.modifiedDate ??
        reference.auditData?.createdDate ??
        'Sin registro';
      group.verifiedBy = reference.auditData?.modifiedBy ?? 'No registrado';
      group.comments = reference.comments ?? '';
    }
  }

  applyHistoryFilter() {
    this.filteredVerifiedPayments = this.verifiedPayments.filter((group) => {
      if (this.historyStatusFilter === 'APPROVED') {
        return group.isApproved;
      }
      if (this.historyStatusFilter === 'REJECTED') {
        return !group.isApproved;
      }
      return true;
    });
  }

  /** Valor de las inscripciones de deportistas según la temporalidad de la inscripción */
  private calculateAmountOfRegistrations(
    registrations: Registration[],
    temporalType: string
  ): number {
    let totalAmount = 0;
    for (const registration of registrations) {
      const competition = this.getCompetition(registration.competitionId);
      if (!competition) {
        continue;
      }
      const athleteAmount =
        temporalType === TemporalRegistration.ORDINARY
          ? competition.registerAmounts?.ordinary?.athlete
          : competition.registerAmounts?.extraordinary?.athlete;

      if (typeof athleteAmount === 'number') {
        totalAmount += athleteAmount;
      } else {
        totalAmount += athleteAmount?.length ? athleteAmount[0].amount : 0;
      }
    }
    return totalAmount;
  }

  private calculateClubAmount(clubRegistration?: Registration): number {
    if (!clubRegistration) {
      return 0;
    }
    const competition = this.getCompetition(clubRegistration.competitionId);
    if (!competition) {
      return 0;
    }
    return clubRegistration.temporalType === TemporalRegistration.ORDINARY
      ? competition.registerAmounts?.ordinary?.club ?? 0
      : competition.registerAmounts?.extraordinary?.club ?? 0;
  }

  getRegistrationStatusLabel(status?: string): string {
    switch (status) {
      case RegistrationStatus.REGISTERED:
        return 'Inscrito';
      case RegistrationStatus.PRE_REGISTERED:
        return 'Preinscrito';
      case RegistrationStatus.NOT_REGISTERED:
        return 'No inscrito';
      default:
        return 'Sin estado';
    }
  }

  getRegistrations(paymentId: string, temporalType: string) {
    const registrationByPayment = this.registrationsByPayment.find(
      (registrationByPayment) => {
        return registrationByPayment.paymentId === paymentId;
      }
    );

    if (registrationByPayment) {
      return registrationByPayment.registrations.filter(
        (registration: Registration) => {
          return registration.temporalType === temporalType && registration.registrationType === RegistrationType.MEMBER_REGISTRATION;
        }
      );
    } else {
      return [];
    }
  }

  calculateAmount(paymentId: string, temporalType: string) {


        
      const registrations:any[]= this.getRegistrations(paymentId, temporalType);

      let totalAmount = 0;

      for (let registration of registrations) {
        
        const competition = this.getCompetition(registration.competitionId);
        const athleteAmount = temporalType === TemporalRegistration.ORDINARY
          ? competition!.registerAmounts.ordinary.athlete
          : competition!.registerAmounts.extraordinary.athlete;
        
        // Handle both number and EventAmountItem[] formats
        if (typeof athleteAmount === 'number') {
          totalAmount += athleteAmount;
        } else {
          // For EventAmountItem[], we'll use the first amount as default
          // In a real implementation, this would calculate based on the number of events the athlete registered for
          totalAmount += athleteAmount.length > 0 ? athleteAmount[0].amount : 0;
        }
      }

      return totalAmount;
    
  }

  calculateTotalAmount(paymentId: string) {
    return (
      this.calculateAmount(paymentId, TemporalRegistration.ORDINARY) +
      this.calculateAmount(paymentId, TemporalRegistration.EXTRAORDINARY) +
      this.getClubAmount(paymentId)
    );
  }

  getClubAmount(paymentId: string) {
    const registrationOfClub = this.registrationsWithManualPayment.find(
      (registration: Registration) => {
        return (
          registration.payment.paymentId === paymentId &&
          registration.registrationType === RegistrationType.CLUB_REGISTRATION
        );
      }
    );

    if (registrationOfClub) {
      const competition = this.getCompetition(registrationOfClub.competitionId);
      return registrationOfClub.temporalType === TemporalRegistration.ORDINARY
        ?competition!.registerAmounts
            .ordinary.club
        : competition!.registerAmounts
            .extraordinary.club;
    }
    return 0;
  }

  openRegistrations(registrationByPayment: any) {
    this.membersOfPayment = [];
    this.showVinculationDetails = false;

    // El grupo recibido ya contiene sus inscripciones, así funciona tanto para
    // las validaciones pendientes como para el historial de verificaciones.
    this.paymentGroupSelected = registrationByPayment;
    this.registrationsByPaymentSelected = registrationByPayment.registrations;

    const membersId = Array.from(
      new Set(
        this.registrationsByPaymentSelected
          .filter(
            (registration: Registration) =>
              !!registration.memberId &&
              registration.registrationType ===
                RegistrationType.MEMBER_REGISTRATION
          )
          .map((registration: Registration) => registration.memberId as string)
      )
    );

    if (membersId.length === 0) {
      this.buildRegistrationsOfPaymentDetail();
      this.showVinculationDetails = true;
      return;
    }

    this.getMembersByIds(membersId);
  }

  /**
   * Arma el detalle a partir de las inscripciones del pago y les asocia el deportista
   * cuando existe. Así el modal siempre muestra el total de inscripciones pagadas,
   * incluidas aquellas cuyo deportista fue eliminado por el club después de inscribirlo.
   */
  buildRegistrationsOfPaymentDetail() {
    this.registrationsOfPaymentDetail = this.registrationsByPaymentSelected
      .filter(
        (registration: Registration) =>
          registration.registrationType === RegistrationType.MEMBER_REGISTRATION
      )
      .map((registration: Registration) => {
        const member = this.membersOfPayment.find(
          (memberOfPayment: Member) => memberOfPayment.id === registration.memberId
        );
        return {
          hasMember: !!member,
          memberId: registration.memberId ?? '',
          rol: member?.rol ?? '',
          clubName:
            member?.club?.name ?? this.getClub(registration.clubId)?.name ?? '',
          modalidad: member?.modalidad ?? '',
          name: member?.name ?? 'Deportista eliminado del club',
          lastName: member?.lastName ?? '',
          idType: member?.idType ?? '',
          idNumber: member?.idNumber ?? '',
          statusLabel: this.getRegistrationStatusLabel(registration.status),
          registrationDate: registration.auditData?.createdDate ?? '',
          temporalLabel:
            registration.temporalType === TemporalRegistration.ORDINARY
              ? 'Ordinaria'
              : 'Extraordinaria',
          competitionName:
            this.getCompetition(registration.competitionId)?.name ?? '',
        };
      });

    this.orphanRegistrationsCount = this.registrationsOfPaymentDetail.filter(
      (row) => !row.hasMember
    ).length;
  }

  /**
   * Consulta en una sola petición todos los inscritos del pago. Se asigna el arreglo
   * completo de una vez para que la tabla del modal conozca el total y pagine.
   */
  getMembersByIds(membersId: string[]) {
    this.loadingService.showLoading();
    const conditionals = membersId.map((id, index) => ({
      conditionalConnector: 'OR',
      logicOperator: '=',
      evaluatedProperty: 'id',
      parameterName: `@MemberId${index}`,
      parameterValue: id,
    }));

    const options: QueryOptionDto = {
      options: { conditionals: conditionals },
    };

    const entity: AdministratorEntity = {
      operation: AcademyAdministratorOperation.SELECT,
      type: AcademyAdministratorType.MEMBERS_MASSIVE,
      payload: options,
    };

    this.gestionService.sendRequest(entity).subscribe({
      next: (response: HttpResponse) => {
        this.membersOfPayment =
          response.code === 200 && Array.isArray(response.response)
            ? (response.response as Member[])
            : [];
        this.buildRegistrationsOfPaymentDetail();
        this.showVinculationDetails = true;
        this.loadingService.hideLoading();
      },
      error: () => {
        this.membersOfPayment = [];
        this.buildRegistrationsOfPaymentDetail();
        this.showVinculationDetails = true;
        this.loadingService.hideLoading();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No fue posible consultar los inscritos asociados al pago',
          life: 4000,
        });
      },
    });
  }

  /** Exporta a Excel los inscritos asociados al pago que se está consultando */
  exportRegistrationsOfPayment() {
    const dataToPrint = this.registrationsOfPaymentDetail.map((row: any) => ({
      Club: row.clubName,
      Rol: row.rol,
      Modalidad: row.modalidad,
      Nombres: `${row.name}`.toUpperCase(),
      Apellidos: `${row.lastName}`.toUpperCase(),
      'Tipo Identificación': row.idType,
      Identificación: row.idNumber,
      Estado: row.statusLabel,
      'Fecha Inscripción': row.registrationDate,
      'Tipo Inscripción': row.temporalLabel,
      Evento: row.competitionName,
      'Deportista Existe': row.hasMember ? 'Si' : 'No',
      'Id Deportista': row.memberId,
      'Referencia Pago': this.paymentGroupSelected?.paymentId ?? '',
    }));

    const reportName = `Inscritos del pago ${
      this.paymentGroupSelected?.clubName ??
      this.getClub(this.paymentGroupSelected?.clubId)?.name ??
      ''
    } ${moment().format('DD-MM-YYYY')}`;

    this.reportService.exportExcel(
      [{ data: dataToPrint, sheetName: 'Inscritos' }],
      reportName.trim()
    );
  }

  validateRegistration(registrationByPayment: any) {
    this.registrationsByPaymentSelected = registrationByPayment.registrations;
    this.showRevisionConceptModal = true;
  }

  showSupport(registrationByPayment: any) {
    this.loadingService.showLoading();
    this.documentsService
      .getDocument(registrationByPayment.paymentId)
      .subscribe((res: HttpResponse) => {
        this.loadingService.hideLoading();
        if (res.response.id) {
          this.documentPreviewSelected = {
            documentName: `Soporte de pago de inscripción a evento`,
            base64: this.sanitizer.bypassSecurityTrustResourceUrl(
              res.response.filestream
            ),
          };
          this.showDocumentPreview = true;
        } else {
          this.documentPreviewSelected = null;
          this.showDocumentPreview = false;

          this.messageService.add({
            severity: 'warn',
            summary: 'Sin Carnet Digital',
            detail: 'No se ha encontrado carnet Digital',
            life: 3000,
          });
        }
      });
  }

  getSeverity(status: string) {
    switch (status) {
      case 'created':
        return 'PENDIENTE REVISIÓN';
      case 'approved':
        return 'APROBADA';
      case 'responsed':
        return 'RESPUESTA ENVIADA';
      case 'responsed_rejected':
        return 'RESPUESTA RECHAZADA ENVIADA';
      case 'responsed_approved':
        return 'RESPUESTA APROBADA ENVIADA';
      case 'rejected':
        return 'RECHAZADA';
      case 'finished':
        return 'FINALIZADA';
      case 'payment_started':
        return 'En proceso de pago';
      case 'finished_approved':
        return 'Vinculado';
      case 'finished_declined':
        return 'Finalizado pago rechazado';
      case 'finished_error':
        return 'Finalizado error de pago';
      case 'finished_payment_rejected':
        return 'Finalizado pago rechazado';
      case 'accepted_payment_pending':
        return 'Aprobado - Pendiente de Pago';
      case 'finished_payment_error':
        return 'Error en Pago';
      case 'payment_manual_validation':
        return 'Pago en Revisión Manual';
      case 'payment_abandoned':
        return 'Pago Abandonado';

      default:
        return 'Estado Desconocido';
    }
  }

  getHumanTime(time: number) {
    return moment(time).format('DD/MM/yyyy hh:mm:ss a');
  }

  clear(table: Table) {
    table.clear();
  }

  onCancelPaymentResponse() {
    this.registrationsByPaymentSelected = [];
    this.showRevisionConceptModal = false;
  }

  onConfirmPaymentResponse() {
    this.loadingService.showLoading();
    // Se deja constancia de quién y cuándo emitió el concepto para el historial
    const verifiedBy = this.roleService.getUserName();
    const verificationDate = moment().format('YYYY-MM-DD HH:mm:ss');
    const registrationsToUpdate = this.registrationsByPaymentSelected.map(
      (registration: Registration) => {
        registration.auditData = {
          ...registration.auditData,
          modifiedBy: verifiedBy,
          modifiedDate: verificationDate,
        };
        if (this.paymentStatusSelected === ProcessStatus.REJECTED) {
          registration.payment.paymentStatus =
            RegistrationPaymentStatus.PAYMENT_MANUALLY_REJECTED;
          registration.payment.paymentManualRevisionNotification = true;
          registration.comments = this.paymentRejectReason;
          return registration;
        }
        registration.payment.paymentManualRevisionNotification = true;
        registration.payment.paymentStatus =
          RegistrationPaymentStatus.PAYMENT_MANUALLY_APPROVED;
        return registration;
      }
    );
    let totalRegistrationsUpdated = 0;
    for (let registrationToUpdate of registrationsToUpdate) {
      const entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.UPDATE,
        type: AcademyAdministratorType.REGISTRATIONS,
        payload: registrationToUpdate,
      };

      this.competitionService
        .sendRequest(entity)
        .subscribe((response: HttpResponse) => {
          if (response.code === 200) {
            totalRegistrationsUpdated++;
            if (totalRegistrationsUpdated === registrationsToUpdate.length) {
              this.messageService.add({
                severity: 'success',
                summary: 'Inscripciones Actualizadas',
                detail:
                  'La respuesta de verificación del pago han sido enviadas correctamente',
                life: 3000,
              });
              this.registrationsByPaymentSelected = [];
              this.showRevisionConceptModal = false;
              this.getVinculationWithManualPayment();
              this.loadingService.hideLoading();
            }
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error al actualizar el pago de las solicitudes',
              detail: 'Ha ocurrido un error al actualizar las solicitudas',
              life: 3000,
            });
            this.loadingService.hideLoading();
          }
        });
    }
  }

  getRegisterOfMember(memberId:string){
    return this.registrationsByPaymentSelected.find((registration:Registration) => registration.memberId === memberId);
  } 

  getRegisterOfClub(clubId:string){
    return this.registrationsByPaymentSelected.find((registration:Registration) => registration.clubId === clubId);
  } 
  
}
